/**
 * **getAllEvents
 * @returns { Array } List of all events
 */

type EventConfigsByMessageMedium = {
  [key: string]: { text: string; events: Record<string, string> };
};

export const getAllEvents = (eventConfigsByMessageMedium: EventConfigsByMessageMedium) =>
  Object.values(eventConfigsByMessageMedium).reduce(
    (acc, { events = {} }) => [...acc, ...Object.keys(events)],
    [] as string[],
  );

/** Returns a list of the events that will be changed due to drodown selection */
export const getEventsForDropdown = (eventOptions: EventConfigsByMessageMedium, value: string) => {
  switch (value) {
    case 'all':
    case 'none':
      return getAllEvents(eventOptions);
    default:
      return Object.keys(eventOptions[value].events);
  }
};
/** Checks if required feature flags are enabled, whether all (if requireOnlyOneFlag is false/undefined)
 * or at least one (if requireOnlyOneFlag is true). */
export const areFeatureFlagsEnabled = (
  requiredFeatureFlags: string[] = [],
  featureFlags: Record<string, boolean> = {},
  requireOnlyOneFlag?: boolean,
) => {
  const isFlagEnabled = (flag: string) => !!featureFlags[flag];
  return requireOnlyOneFlag
    ? requiredFeatureFlags.some(isFlagEnabled)
    : requiredFeatureFlags.every(isFlagEnabled);
};

/** Checks if some required feature flags are enabled based on event name. */
export const areSomeFeatureFlagsEnabled = (
  events: string[] = [],
  requiredFeatureFlagsByEvent: Record<string, string[]> = {},
  featureFlags: Record<string, boolean> = {},
) =>
  events.some((event) => {
    const featureFlagsByEvent = requiredFeatureFlagsByEvent[event];
    if (!featureFlagsByEvent) return true;
    return areFeatureFlagsEnabled(featureFlagsByEvent, featureFlags);
  });
